export default __webpack_public_path__ + "static/media/69_desktop.77ef1bc3.jpg";